export default "__VITE_ASSET__DpZbuAjg__"